import React from 'react';

class QuickSearch extends React.Component {
  constructor(props) {
    super(props);
    this.handleTypeSearch = this.handleTypeSearch.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleClickSearch = this.handleClickSearch.bind(this);
    this.state = {
      searchKeyword: '',
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.searchKeyword !== nextProps.searchKeyword) {
      if (!nextProps.initialized) {
        this.setState({ searchKeyword: nextProps.searchKeyword });
      }
    }
  }
  render() {
    return (
      <div className= { 'input-group input-group-sm search-filter ' }>
        <input
          type="text"
          value={ this.state.searchKeyword }
          placeholder={ this.props.placeholder || 'Search' }
          className="form-control"
          onChange={ this.handleTypeSearch }
          onKeyPress={ this.handleKeyPress } />
        <div className="input-group-btn">
          <button className="btn btn-default" onClick={ this.handleClickSearch } title="Search">
            <i className="fa fa-search"></i>
          </button>
        </div>
      </div>
    );
  }
  handleTypeSearch(event) {
    const search = event.currentTarget.value;
    this.setState({ searchKeyword: search });
  }
  handleClickSearch() {
    this.props.onSearch(this.state.searchKeyword);
  }
  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.props.onSearch(this.state.searchKeyword);
    }
  }
}

export default QuickSearch;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/QuickSearch.jsx